import { extractDataFromResponse, useErrorReporter } from '@mdlinx/frontend-shared';
import { Auth } from '@mdlinx/shared';
import URLSearchParams from '@ungap/url-search-params';
import { useSetAcquisitionParamsMutation } from 'generated/client';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, getLocationDetails } from '../../lib/analytics';

function sendMessage(message: Auth.SetAcquisitionParamsResult) {
  if (window.parent) {
    window.parent.postMessage(message, '*');
  }
}

export const SetAcquisitionParams: React.FC = () => {
  const reporter = useErrorReporter();
  const [setAcquisitionParams] = useSetAcquisitionParamsMutation();
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const urlParams = new URLSearchParams(location.search);
      const vendorId = urlParams.get('vndid');
      const vendorUserId = urlParams.get('mdlaq');
      const input = {
        vendorId: Number(vendorId),
        vendorUserId: vendorUserId as string,
      };

      setAcquisitionParams({ variables: { input } })
        .then(extractDataFromResponse)
        .then(
          ({ setAcquisitionParams }) => {
            switch (setAcquisitionParams.__typename) {
              case 'SetAcquisitionParamsSuccess':
                trackEvent('auth_set_acquisition_params_succeeded', {
                  params: input,
                  action: 'SetAcquisitionParams',
                  ...getLocationDetails(location.pathname, location.search),
                });
                sendMessage(Auth.setAcquisitionParamsSucceeded);
                return;
              case 'SetAcquisitionParamsFailure':
                trackEvent('auth_set_acquisition_params_failed', {
                  params: input,
                  action: 'SetAcquisitionParams',
                  ...getLocationDetails(location.pathname, location.search),
                });
                return sendMessage(Auth.setAcquisitionParamsFailed);
            }
          },
          e => {
            reporter.report(e);
            sendMessage(Auth.setAcquisitionParamsFailed);
          },
        );
      return () => {};
    }

    return;
  }, [location.search, setAcquisitionParams, reporter]);
  return null;
};
